import { ResponseMessageWithInternalStatus } from "../dto/response-message-with-internal-status.dto";

export interface FormaPago {
  id: number;
  abreviatura: string;
  nombre: string;
  codigo: string;
  leyenda: string;
  condicionVentaARCA: {
    id: string;
  };
}

export interface FormaPagos {
    formasPago: FormaPago[];
}

export interface ObtenerListadoFormaPago extends ResponseMessageWithInternalStatus{
  formasPago: {
    id: number;
    abreviatura: string;
    nombre: string;
    codigo: string;
    leyenda: string;
    condicionVentaARCA: {
      id: string;
    };
  }[];
}

export interface FormaPagosState {
  formaPagos: FormaPago[];
  error: boolean;
  debugMessage?: any;
}

export const initialFormaPagosState: FormaPagosState = {
  formaPagos: [],
  error: false,
  debugMessage: null
};